import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import headerRightBg from '../images/secure-transfer/headerRightBg.png';
import headerRightBg375 from '../images/secure-transfer/headerRightBg375.png';
import ManFolderCloud from '../images/secure-transfer/ManFolderCloud.svg';
import EmailContactSales from '../components/EmailContactSales';
import ProblemSolution from '../components/ProblemSolution';
import FeaturesAndBenefits from '../components/FeaturesAndBenefits';
import ComputerKeyPhone from '../images/secure-sign/ComputerKeyPhone.svg';
import FilePhone from '../images/secure-transfer/FilePhone.svg';
import Email from '../images/secure-transfer/Email.svg';
import FlyingFolderLock from '../images/secure-transfer/FlyingFolderLock.svg';
import WantToSeeHow from '../components/WantToSeeHow';
import FinancialInstitutions from '../components/FinancialInstitutions';

const HeaderContent = styled.article`
	padding-bottom: 1em;
	display: flex;
	flex-direction: column;

	& h1 {
		min-height: 0;
	}

	& p {
		max-width: 490px;
	}
`;

const SecureTransferHeaderContent =
	<HeaderContent style={{marginTop: `0`, paddingTop: `75px`, paddingBottom: `60px`}}>
		<h1>SecureTransfer</h1>
		<p>Safe and secure<br />file transmission</p>
		<EmailContactSales />
	</HeaderContent>
;

const HeaderBottomContentFigure = styled.figure`

	& svg.bottomAligned {
		max-width: 80%;
		margin-top: 1em;
		margin-bottom: 2em;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
			margin-top: 0;
			margin-bottom: 2em;
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 484px;
			margin-bottom: 4em;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
			margin-bottom: 4em;
		}
	}
`;

const ManFolderCloudFigure =
	<HeaderBottomContentFigure>
		<ManFolderCloud alt='Man at desk looking at connected apps' className='bottomAligned' />
	</HeaderBottomContentFigure>
;

const Section = styled.section`
	border: none;

	&#SecuresTransferSplit .product.text-box h2{
		@media (${(props) => props.theme.xLargeUp}) {
			white-space: nowrap;
		}
	}
`;

const FeaturesAndBenefitsSyle = { marginBottom: '0' };

const SecureTransferPage = (props: any) => {
	return (
	<Layout
		headerSplashBg375={headerRightBg375}
		headerSplashBgSize={'100% 100%'}
		headerSplashBgPosition={'center top'}

		headerSplashBg={headerRightBg}
		headerSplashBgSizeLarge={'auto'}
		headerSplashBgPositionLarge={'center bottom'}
		headerSplashAlignItemsLarge={'flex-end'}
		headerBottomContent={ManFolderCloudFigure}
		headerContentClass={'product'}
		headerContent={SecureTransferHeaderContent}
		headerContentMaxWidth={'490px'}
		headerSplashBgAverageColor={'white'}
		pageTitle='SecureTransfer - Digital file sharing'
		metaDescription={'Digitize the customer onboarding experience with our quick and secure document transfers so paper files and shipping charges can be put to rest.'}
		skipMoney2020={true}
		splashHeaderMinHeight={'500px'}
		BodyClass={'SecureTransfer'}
	>
		<ProblemSolution
			problem={'Customers and financial institutions alike are spending valuable time and money mailing sensitive documents back and forth causing friction with customers and delaying the loan process.'}
			solution={'SecureTransfer streamlines the digital onboarding process by allowing customers to upload sensitive documents in a cost-effective and safe environment.'}
		/>
		<FeaturesAndBenefits
			extraStyle={FeaturesAndBenefitsSyle}
			solidBgColor = {'#3498d3'}

			leftIcon = {<ComputerKeyPhone alt='phone, computer and key icon' style={{margin: `5px 0`}} />}
			leftHeading = {'Two-factor\nauthentication'}
			leftText={'Maximize data protection and login security.'}

			middleIcon = {<FilePhone alt='File, Phone icon' style={{margin: `0`}} />}
			middleHeading = {'Digital file\ntransfer'}
			middleText = {'Minimize shipping costs with convenient file sharing from any device.'}

			rightIcon = {<Email alt='Email icon' style={{margin: `0`}} />}
			rightHeading = {'Email\nnotifications'}
			rightText = {'Receive emails for new applications to accelerate the loan process.'}
		/>
		<div className='centeredWrapper'>
			<Section className='fast-simple row row-flush centered' id='SecuresTransferSplit'>
				<article className='col-12 col-md-6 '>
					<div className='product text-box'>
						<header>
							<h2>The fast, simple, and secure way to transmit documents</h2>
						</header>
						<p>Financial institutions are held to the highest standards for protecting sensitive customer data, but shipping files is expensive and risky. Meet rising customer expectations for a digital front-end experience without altering your back-office underwriting process.</p>
						<p>Say hello to a fast, simple, and secure way to transmit documents that saves you money and maintains the integrity of your customer's data.</p>
					</div>
				</article>
				<figure className='col-12 col-md-6 left-on-desktop'>
					<FlyingFolderLock alt='secure file transfer' />
				</figure>
			</Section>
			<FinancialInstitutions />
			<WantToSeeHow />
		</div>
	</Layout>
	);
};

export default SecureTransferPage;
